import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/site';
import { categories } from '@/mocks/categories';

const BackToTop = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!show) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      className="fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full bg-accent-500 text-background-50 flex items-center justify-center cursor-pointer transition-colors hover:bg-accent-600"
    >
      <i className="ri-arrow-up-line text-lg" />
    </button>
  );
};

const SiteFooter = () => (
  <footer className="bg-primary-950 text-primary-100 mt-16">
    <div className="px-4 md:px-6 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
      <div className="lg:col-span-1">
        <div className="flex items-center gap-2.5 mb-3">
          <span className="w-9 h-9 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
            <i className="ri-fire-fill text-lg" />
          </span>
          <span className="font-heading text-lg font-black text-background-50">爆瓜爆料</span>
        </div>
        <p className="text-sm leading-6 text-primary-200">{siteInfo.slogan}</p>
        <p className="text-sm leading-6 text-primary-300 mt-3">
          投稿与线索：<span className="text-secondary-300">{siteInfo.email}</span>
        </p>
      </div>

      <nav aria-label="栏目导航">
        <h4 className="font-heading text-sm font-bold text-background-50 mb-3">栏目导航</h4>
        <ul className="space-y-2 text-sm">
          {navLinks.slice(1, 6).map((item) => (
            <li key={item.to}>
              <Link to={item.to} className="text-primary-200 transition-colors hover:text-background-50">
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="热门分类">
        <h4 className="font-heading text-sm font-bold text-background-50 mb-3">热门分类</h4>
        <ul className="space-y-2 text-sm">
          {categories.slice(0, 5).map((cat) => (
            <li key={cat.slug}>
              <Link
                to={`/category/${cat.slug}`}
                className="text-primary-200 transition-colors hover:text-background-50"
              >
                {cat.name}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <nav aria-label="关于与帮助">
        <h4 className="font-heading text-sm font-bold text-background-50 mb-3">关于与帮助</h4>
        <ul className="space-y-2 text-sm">
          <li>
            <Link to="/about" className="text-primary-200 transition-colors hover:text-background-50">
              关于我们
            </Link>
          </li>
          <li>
            <Link to="/faq" className="text-primary-200 transition-colors hover:text-background-50">
              常见问题
            </Link>
          </li>
          <li>
            <Link to="/contact" className="text-primary-200 transition-colors hover:text-background-50">
              联系我们
            </Link>
          </li>
        </ul>
      </nav>
    </div>

    <div className="border-t border-primary-900 px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-primary-300">
      <span>© 2026 爆瓜爆料 · 全网娱乐快讯聚合</span>
      <span>内容以核实为准，转载请注明出处</span>
    </div>
    <BackToTop />
  </footer>
);

export default SiteFooter;